'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var STYLE_KEYS = exports.STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];

var LOCK_STYLES = exports.LOCK_STYLES = {
  boxSizing: 'border-box', // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};


//////////////////
// WEBPACK FOOTER
// ./~/react-select/lib/internal/ScrollLock/constants.js
// module id = 1027
// module chunks = 170434399708630